import { Box, Button, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Icons } from "./../Icons";
import moment from "moment";
import ModalTrazabilidad from "./../ModalTrazabilidad";

interface ColumnsProps {
  handleVerClick: (uuid: string, link: string) => void;
  urlOrigen?: string;
  rows: any[]; // 🔥 IMPORTANTE: Ahora recibes rows
}

const getColumnsVerificacionAE = ({
  handleVerClick,
  urlOrigen,
  rows
}: ColumnsProps): GridColDef[] => {
  const formatNumber = (value: any) => {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const columns: GridColDef[] = [
    {
      field: "municipio",
      headerName: "Municipios",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (cellValues: any) => {
        return <p>{cellValues.row.municipio}</p>;
      },
    },
    {
      field: "FOULT",
      headerName: "Fondo de Ultracrecimiento Municipal",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FOULT)}</p>;
      },
    },
    {
      field: "FODES",
      headerName: "Fondos Descentralizados",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FODES)}</p>;
      },
    },
    {
      field: "FOSEGMUN",
      headerName: "Fondos de Seguridad para los Municipios",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FOSEGMUN)}</p>;
      },
    },
    {
      field: "FOINMUN",
      headerName: "Fondo de Infraestructura para los Municipios",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FOINMUN)}</p>;
      },
    },
    {
      field: "total_monto",
      headerName: "TOTALES",
      width: 250,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.total_monto)}</p>;
      },
    },

  ];
  const filteredColumns = columns.filter(col =>
    rows.some(row => row[col.field] !== undefined && row[col.field] !== null)
  );
  return filteredColumns;
};

export default getColumnsVerificacionAE;
